import { lazy } from 'react'
import PayrunsLoader from './pay-runs/loader'
import EditPayRunLoader from './pay-runs/edit/loader'

export default {
  Payruns: {
    Component: lazy(() => import('./pay-runs/PayRuns.Page')),
    Loader: PayrunsLoader,

    Edit: {
      Component: lazy(() => import('./pay-runs/edit/EditPayRun.Page')),
      Loader: EditPayRunLoader,
    },
  },
}
